import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { apiUrl } from 'src/app/config';
import { sitosApiUrl } from 'src/app/graphql.module';


@Injectable({
    providedIn: 'root',
  })
export class ImageReader {
  constructor(
    private http: HttpClient
    ) {}

  /**
   * Gets the images from the server as Blob
   *
   * Der Access-Token wird NUR an bekannte Origins gesendet (eigene Origin oder
   * API-Origin, siehe #mayReceiveToken). Die Bild-URL stammt aus der
   * Backend-Konfiguration (units.defaultUnit.logoUrl bzw. configs.configData.iconUrl)
   * und ist damit nicht per se vertrauenswuerdig: zeigt sie auf einen fremden Host,
   * wuerde ein bedingungsloser Authorization-Header den Token dorthin ausleiten.
   * Fremde Hosts werden weiterhin geladen – nur eben ohne Token.
   */
   public getImage(url: string): Observable<Blob> {

    // Kein Content-Type: ein GET hat keinen Body, der Header war wirkungslos und
    // behauptete faelschlich image/jpeg.
    const headers = this.#mayReceiveToken(url)
      ? new HttpHeaders({
          'Accept': '*/*',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        })
      : new HttpHeaders({ 'Accept': '*/*' });

    return this.http.get(url, { headers: headers, responseType: 'blob' });

  }

  /**
   * Allowlist fuer den Access-Token. Exaktes Origin-Matching (keine Wildcard, keine
   * Subdomain-Heuristik) auf die drei Hosts, die das Frontend kennt:
   *  - eigene Origin (deckt auch relative URLs ab),
   *  - members-api (apiUrl),
   *  - sitos-x-api (sitosApiUrl) – von dort kommen die Logos.
   * Frontend und die beiden APIs laufen auf verschiedenen Hosts, daher reicht eine
   * reine window.location.origin-Pruefung nicht.
   */
  #mayReceiveToken(url: string): boolean {
    try {
      const target = new URL(url, window.location.origin);
      return target.origin === window.location.origin
          || target.origin === new URL(apiUrl).origin
          || target.origin === new URL(sitosApiUrl).origin;
    } catch {
      // Unparsbare URL -> im Zweifel keinen Token mitschicken.
      return false;
    }
  }
  /**
   * Requests files
   */
   public requestFile(url: string): Observable<Blob> {
    let auth_token = localStorage.getItem("access_token");

    const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*',
        Authorization: `Bearer ${auth_token}`,
      });
 
    return this.http.get(url, { headers: headers, responseType: 'blob' });
    
  }

  /**
   * Convert base64 to blob
   */
  public convertBase64toBlob(base64Data: any, contentType: any): Blob {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);
  
    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);
  
      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }
}
